<template lang="pug">
v-layout(align-center wrap).game-panel.py-1.px-3
  .title.mr-2 {{ game.title || "[No title]" }}

  v-btn.mr-1(icon small title="Edit game name" @click="showEditDialog = true")
    v-icon(small) edit
  v-dialog(v-model="showEditDialog" max-width="500")
    edit-game-form(:game="game" @close-dialog="showEditDialog = false")

  folder-icon(:folderId="game.folderId")
  file-uploader(v-if="game.folderId" :folderId="game.folderId")
  spreadsheet-icon(:spreadsheetId="game.spreadsheetId")

  v-tooltip(top)
    | Resync all spreadsheets
    template(v-slot:activator="{ on }")
      v-btn(icon small tile v-on="on" @click="resyncSheets" :loading="resyncing")
        v-icon(small) mdi-refresh

  v-spacer

  v-btn(small @click="showPrintPdfDialog = true")
    v-icon(left small) photo_library
    | Print PDF
  v-dialog(v-model="showPrintPdfDialog" max-width="500")
    print-settings(:game="game" @close-dialog="showPrintPdfDialog = false" @confirm="printGame")

  v-btn.ml-1(small @click="showExportPngDialog = true")
    v-icon(left small) mdi-image-multiple
    | Export PNG
  v-dialog(v-model="showExportPngDialog" max-width="500")
    export-png-dialog(:game="game" @close-dialog="showExportPngDialog = false" @confirm="exportPng")

  v-btn.ml-1(small @click="showDeleteDialog = true")
    v-icon(left small) delete
    | Delete
  v-dialog(v-model="showDeleteDialog" max-width="500")
    v-card.delete-game
      v-card-title.subtitle-1 Delete "{{ game.title }}"?
      v-card-text.caption This cannot be undone.
      v-card-actions
        v-spacer
        v-btn(text small @click="showDeleteDialog = false") Cancel
        v-btn(text small color="error" @click="deleteGame") Delete
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import pdfRenderer from '../../services/pdf_renderer'
  import EditGameForm from './EditGameForm.vue'
  import FolderIcon from '../icons/FolderIcon.vue'
  import FileUploader from '../shared/FileUploader.vue'
  import SpreadsheetIcon from '../icons/SpreadsheetIcon.vue'
  import PrintSettings from '../print/PrintSettings.vue'
  import ExportPngDialog from '../print/ExportPngDialog.vue'

  export default {
    props: ["game"],

    components: {
      EditGameForm,
      FolderIcon,
      FileUploader,
      SpreadsheetIcon,
      PrintSettings,
      ExportPngDialog,
    },

    data() {
      return {
        showEditDialog: false,
        showDeleteDialog: false,
        showPrintPdfDialog: false,
        showExportPngDialog: false,
        resyncing: false
      }
    },

    computed: {
      ...mapGetters(['findAllGameComponents']),

      gameSpreadsheetIds() {
        const ids = new Set()
        if (this.game.spreadsheetId) ids.add(this.game.spreadsheetId)
        this.findAllGameComponents(this.game).forEach(c => {
          if (c.spreadsheetId) ids.add(c.spreadsheetId)
        })
        return [...ids]
      }
    },

    methods: {
      ...mapActions(["destroyGame", "refreshSheetIndex"]),

      async resyncSheets() {
        this.resyncing = true
        try {
          await Promise.all(this.gameSpreadsheetIds.map(id => this.refreshSheetIndex(id)))
        } finally {
          this.resyncing = false
        }
      },

      deleteGame() {
        this.$router.push({ name: "gameManager" })
        return this.destroyGame(this.game)
      },

      printGame() {
        pdfRenderer.renderGameToPdf(this.game)
      },

      exportPng() {
        pdfRenderer.renderGameToPng(this.game)
      }
    }
  }
</script>
